<template>
  <div v-if="status > 1" class="tw-mt-[50px]">
    <div v-if="mode == 'practice'">
      <div class="sentence">
        Congratulations you completed this activity. You can choose to practice
        the words again or test yourself.
      </div>
      <div class="final-spelling-points">
        You scored {{ spellingPoints }} Spelling Points
      </div>
      <div>
        <button class="sf-btn-primary" @click.prevent="$emit('close')">
          Close
        </button>
      </div>
    </div>
    <div>
      <template v-if="status == 2">
        <h3>Test results have been saved successfully</h3>
        <div v-if="isPerfectScore">
          <p>You got all your spellings correct first time.</p>
          <p>You have earned 50 extra Spelling Points.</p>
        </div>
      </template>
      <template v-else-if="status == 3">
        You scored {{ spellingPoints }} Spelling Points
      </template>
      <div>
        <button
          type="button"
          class="sf-btn-primary"
          @click.prevent="$emit('showresults')"
        >
          Show Results
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
  spellingActivitySaveData,
  spellingActivitySaveStatus,
  spellingActivityIsPerfect,
} from "@/state/spellingGameState";
import { SfActivityMode } from "@/types/sfActivityTypes";

export default defineComponent({
  emits: ["close", "showresults"],
  computed: {
    status(): number {
      return spellingActivitySaveStatus.value;
    },
    mode(): SfActivityMode {
      return spellingActivitySaveData.value
        ? spellingActivitySaveData.value.mode
        : "test";
    },
    spellingPoints(): number {
      return spellingActivitySaveData.value
        ? spellingActivitySaveData.value.sfPoints
        : 0;
    },
    isPerfectScore(): boolean {
      if (!spellingActivitySaveData.value?.words) {
        return false;
      }
      return spellingActivityIsPerfect(spellingActivitySaveData.value?.words);
    },
  },
});
</script>
